<template>
    <div class="widget-configuration">
        <Simplebar class="with-border-track">
            <table role="presentation">
                <tr v-for="item in data" :key="item.value">
                    <td>{{ $t(item.label) }}:</td>
                    <td :class="item.class">
                        {{ item.value }}
                    </td>
                </tr>
            </table>
        </Simplebar>
    </div>
</template>

<script>
import Simplebar from 'simplebar-vue';

export default {
    components: {
        Simplebar,
    },

    props: {
        data: {
            type: Array,
            required: true,
        },
    },
};
</script>
